import styled from 'styled-components';
import { Capacitor } from '@capacitor/core';
import 'views/components/Video/MapComponent/styles/leaflet.css';

const MapWrapper = styled.div`
  position: relative;
  overflow: hidden;
  height: 100%;

  .leaflet-container {
    z-index: 0;
    height: 100%;
    width: 100vw;
  }
`;

const Button = styled.div`
  width: 48px;
  height: 48px;
  padding: 8px;

  display: flex;
  align-items: center;
  justify-content: center;

  background: #ffffff;

  cursor: pointer;

  i {
    font-size: 20px;
  }
`;

const ButtonWrapper = styled.div`
  position: absolute;
  z-index: 1;
`;

const MenuButton = styled(ButtonWrapper)`
  left: 8px;
  top: 8px;
`;

const RightBlock = styled(ButtonWrapper)`
  top: 50%;
  transform: translateY(-50%);
  right: 8px;
  > :not(:last-child) {
    margin-bottom: 8px;
  }
`;

const SearchWrapper = styled.div<{ open?: boolean }>`
  position: absolute;
  z-index: 1;
  left: 0;
  bottom: 0;
  ${Capacitor.platform === 'ios' && 'bottom: calc(env(safe-area-inset-top) + 5px);'}

  transform: translateY(${({ open }) => (open ? Capacitor.platform === 'ios'?`env(safe-area-inset-top)`:`0` : `calc(100vh - 105px)`)});

  width: 100%;
  height: 100%;
  padding: 8px;

  background: rgba(255, 255, 255, ${({ open }) => (open ? 1 : 0)});
  transition: all 0.3s ease-in-out;
`;

const AddressItem = styled.div`
  line-height: 18px;
  font-size: 14px;
  padding: 10px 16px;
  cursor: pointer;
  border-bottom: 1px solid rgb(244, 244, 244);
  color: ${({ theme }) => theme.colors.greyLight};;
`;

export const Styled = {
  MapWrapper,
  Button,
  RightBlock,
  MenuButton,
  SearchWrapper,
  AddressItem
};
